import React from "react";
import { Route, Routes } from "react-router-dom";

import Reset from "./reset";
import Forgot from "./forgot";
import Signin from "./signin";
import MagicLink from "./MagicLink";
import Invite from "./invite";
import EmailInvite from "./emailInvite";
import Connect from "./connect";

const Auth = () => {
  return (
    <Routes>
      <Route path="/" element={<Signin />} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/email-invite" element={<EmailInvite />} />
      <Route path="/magic-link" element={<MagicLink />} />
      <Route path="/connect" element={<Connect />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/forgot" element={<Forgot />} />
    </Routes>
  );
};

export default Auth;
